/**
 * @generated SignedSource<<e61c8b2f6c116445d18ac0b7f04f0802>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentsMethodsListContentStep_PaymentOptionConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly paymentMethod: {
        readonly id: string;
        readonly groupName: string;
        readonly name: string;
      };
      readonly installments: {
        readonly edges: ReadonlyArray<{
          readonly __typename: string;
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"PaymentsMethodsListContentBestInstallment_PaymentOption">;
    };
  }>;
  readonly " $fragmentType": "PaymentsMethodsListContentStep_PaymentOptionConnection";
};
export type PaymentsMethodsListContentStep_PaymentOptionConnection$key = {
  readonly " $data"?: PaymentsMethodsListContentStep_PaymentOptionConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentsMethodsListContentStep_PaymentOptionConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentsMethodsListContentStep_PaymentOptionConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentOptionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentOption",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentMethod",
              "kind": "LinkedField",
              "name": "paymentMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "groupName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentOptionInstallmentConnection",
              "kind": "LinkedField",
              "name": "installments",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaymentOptionInstallmentEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PaymentsMethodsListContentBestInstallment_PaymentOption"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PaymentOptionConnection",
  "abstractKey": null
};

(node as any).hash = "ba037ad7da17f423698b353b50d855a1";

export default node;
